import React from "react";
import Chart from "react-apexcharts";

const BarChart = () => {
  const options = {
    chart: {
      type: "bar",
      animations: {
        enabled: true,
        easing: "easeinout",
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
      },
      toolbar: {
        show: true, // Enables the toolbar
        tools: {
          download: false, // Enables the download button
        },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: false, // Makes the bars vertical
        distributed: true, // Different colors for each bar
      },
    },
    xaxis: {
      categories: ["PayIn", "Payout", "Balance"],
      labels: {
        style: {
          colors: ["#495A69", "#495A69", "#495A69"], // Matches bar colors
          fontSize: "14px",
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "14px",
          colors: "#495A69", // Subtle gray for Y-axis labels
        },
      },
    },
    colors: ["#a3d1d5d9", "#A6BED2A3", "#495A69"], // Vibrant bar colors
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#ffffff"], // White labels on bars
        fontSize: "12px",
        fontWeight: "bold",
      },
    },
    grid: {
      borderColor: "#f1f1f1", // Subtle gridlines for better readability
    },
    tooltip: {
      enabled: true,
      style: {
        fontSize: "14px",
        fontFamily: "Arial, sans-serif",
      },
      y: {
        formatter: (value) => `$${value}`, // Adds currency format
      },
    },
    legend: {
      show: false, // Hide legend for simplicity
    },
  };

  const series = [
    {
      name: "Amount",
      data: [5000, 3000, 8000], // Example data: PayIn = 5000, Payout = 3000, Total Balance = 8000
    },
  ];

  return (
    <>
      <h3
        style={{
          textAlign: "center",
          color: "#333",
          marginBottom: "31px",
          color: "#495A69",
        }}
      >
        Today's Financial Overview
      </h3>
      <Chart options={options} series={series} type="bar" height={350} />
    </>
  );
};

export default BarChart;
